/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  DeleteApiV1ClassroomdisciplineClassModulesIdMutationResponse,
  DeleteApiV1ClassroomdisciplineClassModulesIdPathParams,
  DeleteApiV1ClassroomdisciplineClassModulesId401,
  DeleteApiV1ClassroomdisciplineClassModulesId404,
  DeleteApiV1ClassroomdisciplineClassModulesId500,
} from "../../types/classPlanningClassModuleController/DeleteApiV1ClassroomdisciplineClassModulesId.ts";

function getDeleteApiV1ClassroomdisciplineClassModulesIdUrl(
  id: DeleteApiV1ClassroomdisciplineClassModulesIdPathParams["id"],
) {
  const res = {
    method: "DELETE",
    url: `/api/v1/classroomdiscipline/class-modules/${id}` as const,
  };
  return res;
}

/**
 * @description Exclui o Módulo e suas relações (turmas, configurações de disciplina e recorrências). As Aulas vinculadas são apenas desvinculadas do Módulo — não são excluídas. **(Requer Authorization para autenticação)**
 * @summary Excluir Módulo (Requer Authorization para autenticação)
 * {@link /api/v1/classroomdiscipline/class-modules/:id}
 */
export async function deleteApiV1ClassroomdisciplineClassModulesId(
  id: DeleteApiV1ClassroomdisciplineClassModulesIdPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteApiV1ClassroomdisciplineClassModulesIdMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1ClassroomdisciplineClassModulesId401
      | DeleteApiV1ClassroomdisciplineClassModulesId404
      | DeleteApiV1ClassroomdisciplineClassModulesId500
    >,
    unknown
  >({
    method: "DELETE",
    url: getDeleteApiV1ClassroomdisciplineClassModulesIdUrl(id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
